import { render, staticRenderFns } from "./systemAttribute.vue?vue&type=template&id=6807fbf7&scoped=true&"
import script from "./systemAttribute.vue?vue&type=script&lang=js&"
export * from "./systemAttribute.vue?vue&type=script&lang=js&"
import style0 from "./systemAttribute.vue?vue&type=style&index=0&id=6807fbf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807fbf7",
  null
  
)

export default component.exports